import { __decorate, __extends } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import { PageService } from '@/views/copy/feedback/import';
import CommonConfig from '@/common/CommonConfig';
import SVGA from 'svgaplayerweb';
var HuanxunNavLevel = /** @class */ (function (_super) {
    __extends(HuanxunNavLevel, _super);
    function HuanxunNavLevel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.navH = 0;
        _this.statusH = 0;
        _this.isShowNav = true;
        _this.upgradeList = CommonConfig.Common.huanxunUpLevelList;
        _this.currentEquity = CommonConfig.Common.huanxunCurrentEquity;
        _this.nobilityInfo = {};
        _this.APPRoutes = CommonConfig.Common.APPRoutes;
        _this.maxRate = 0;
        _this.bgColor = ['#C7E5C2', '#93C688'];
        return _this;
    }
    Object.defineProperty(HuanxunNavLevel.prototype, "levelNumber", {
        /** 从 currentLevel（如 Lv.1）提取数字等级 */
        get: function () {
            var raw = String(this.nobilityInfo.currentLevel || '');
            var matched = raw.match(/(\d+)/);
            return matched ? matched[1] : '';
        },
        enumerable: false,
        configurable: true
    });
    HuanxunNavLevel.prototype.created = function () {
        var _this = this;
        this.navH = this.awlGlobalState.urlInitParams.navH;
        this.statusH = this.awlGlobalState.urlInitParams.statusH;
        window['doReloadData'] = function () {
            _this.doReloadData();
        };
        this.getUserLevel();
        this.globalCommit('setting_pageJump', 1);
        window.addEventListener('scroll', this.handleScroll);
    };
    HuanxunNavLevel.prototype.unmounted = function () {
        window.removeEventListener('scroll', this.handleScroll);
        this.clearAni();
    };
    HuanxunNavLevel.prototype.handleScroll = function () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.isShowNav = scrollTop <= 0;
    };
    HuanxunNavLevel.prototype.getUserLevel = function () {
        var _this = this;
        PageService.getGoddessInfo({
            package: this.awlGlobalState.urlInitParams.package,
        }).then(function (data) {
            _this.nobilityInfo = data;
            if (data.avatarFrameSvg) {
                setTimeout(function () {
                    _this.playAni();
                }, 100);
            }
            var level = Number(_this.levelNumber);
            switch (level) {
                case 0:
                case 1:
                    _this.bgColor = ['#C7E5C2', '#93C688'];
                    break;
                case 2:
                    _this.bgColor = ['#A2EBC4', '#4EB381'];
                    break;
                case 3:
                    _this.bgColor = ['#94DDF7', '#59B6D3'];
                    break;
                case 4:
                    _this.bgColor = ['#A6E0FF', '#48B0FF'];
                    break;
                case 5:
                    _this.bgColor = ['#D9E1FF', '#8892F3'];
                    break;
                case 6:
                    _this.bgColor = ['#FFC5CB', '#EA51C6'];
                    break;
                case 7:
                    _this.bgColor = ['#EDC2FC', '#B871FF'];
                    break;
                case 8:
                    _this.bgColor = ['#FFE4AE', '#FF3FBE'];
                    break;
                case 9:
                    _this.bgColor = ['#FFBBBB', '#FF3729'];
                    break;
                default:
                    _this.bgColor = ['#FFEB60', '#FF3500'];
                    break;
            }
            _this.maxRate = Math.ceil(data.star);
        });
    };
    HuanxunNavLevel.prototype.playAni = function () {
        var _this = this;
        if (this.player) {
            this.player.clear();
        }
        this.player = new SVGA.Player('#svgBorder');
        var parser = new SVGA.Parser();
        parser.load(this.nobilityInfo.avatarFrameSvg, function (videoItem) {
            _this.player.setVideoItem(videoItem);
            _this.player.startAnimation();
        });
    };
    HuanxunNavLevel.prototype.clearAni = function () {
        if (this.player) {
            this.player.clear();
        }
    };
    HuanxunNavLevel.prototype.toPage = function (index) {
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        this.$router.push({
            path: '/nav/currentEquity',
            query: {
                activeName: index,
                navH: this.awlGlobalState.urlInitParams.navH,
                statusH: this.awlGlobalState.urlInitParams.statusH,
                version: this.awlGlobalState.urlInitParams.version,
                token: this.awlGlobalState.urlInitParams.token,
            },
        });
    };
    HuanxunNavLevel.prototype.toRecord = function () {
        this.$router.push({
            path: '/nav/levelRecord',
            query: {
                navH: this.awlGlobalState.urlInitParams.navH,
                statusH: this.awlGlobalState.urlInitParams.statusH,
                version: this.awlGlobalState.urlInitParams.version,
                token: this.awlGlobalState.urlInitParams.token,
            },
        });
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
    };
    HuanxunNavLevel.prototype.toNativePage = function (url) {
        var params = {
            action: 0,
            route: url,
        };
        this.awlGlobalConfig.messageHandlers(params);
    };
    HuanxunNavLevel.prototype.doReloadData = function () {
        this.getUserLevel();
    };
    HuanxunNavLevel.prototype.toBack = function () {
        if (Number(this.awlGlobalState.pageJump) <= 1) {
            this.globalCommit('setting_pageJump', 1);
            this.awlGlobalConfig.onBack();
            return false;
        }
        else {
            this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) - 1);
            this.$router.go(-1);
        }
    };
    HuanxunNavLevel = __decorate([
        Options({
            name: 'HuanxunNavLevel',
        })
    ], HuanxunNavLevel);
    return HuanxunNavLevel;
}(AvalonGTView.BaseView));
export default HuanxunNavLevel;
